<script>
export default {
  name: 'SearchNormalIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#8E8E8E',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.5 21C16.7467 21 21 16.7467 21 11.5C21 6.25329 16.7467 2 11.5 2C6.25329 2 2 6.25329 2 11.5C2 16.7467 6.25329 21 11.5 21Z"
      :fill="color"
    />
    <path
      d="M21.3005 21.9996C21.1205 21.9996 20.9405 21.9296 20.8105 21.7996L18.9505 19.9396C18.6805 19.6696 18.6805 19.2296 18.9505 18.9496C19.2205 18.6796 19.6605 18.6796 19.9405 18.9496L21.8005 20.8096C22.0705 21.0796 22.0705 21.5196 21.8005 21.7996C21.6605 21.9296 21.4805 21.9996 21.3005 21.9996Z"
      :fill="color"
    />
  </svg>
</template>
